import { joinPathComponents, slugify } from 'utils/canonicalHelpers';

export function makeArtistStationPath(
  artistName: string,
  artistId: string,
): string {
  return !artistName || !artistId
    ? ''
    : joinPathComponents('/artist/', slugify(artistName, artistId));
}
